export const DefaultImage = [
  require('./default-image.png'),
  require('./default-image@2x.png'),
];
